import { appConstants } from '../../../application/configurations/constants';
import { dataReturnFields } from '../../../application/model/data/mapperConfig';
import { documentReturnFields } from '../../../application/model/documents/mapperConfig';
import { bestbetsProperties } from '../../../application/model/bestbets/mapperConfig';
import { peopleReturnFields } from '../../../application/model/people/mapperConfig';

export const getReturnFields = (vertical: string): string[] => {
  switch (vertical) {
    case appConstants.verticals.All:
      return Array.from(
        new Set([
          ...dataReturnFields,
          ...documentReturnFields,
          ...peopleReturnFields
        ])
      );
    case appConstants.verticals.Documents:
    case appConstants.verticals.Credentials:
    case appConstants.verticals.Videos:
      return documentReturnFields;
    case appConstants.verticals.Data:
      return dataReturnFields;
    case appConstants.verticals.People:
      return peopleReturnFields;
    case appConstants.BestBets:
      return Object.keys(bestbetsProperties);
    default:
      return documentReturnFields;
  }
};